import React, { ComponentType, MouseEvent } from 'react';
import moment from 'moment';
import { DateFormats } from 'constants/common';
import { Box, Popover, Stack, Typography } from '@mui/material';

import { CalendarEvent } from './types';
import { getPriorityColor } from './CalendarEventCard';

interface Props {
  date: Date | null;
  onClose: VoidFunction;
  events: CalendarEvent[];
  anchorEl: HTMLElement | null;
  EventComponent?: ComponentType<{ event: CalendarEvent }>;
  onSelectEvent?: (event: CalendarEvent, e: MouseEvent<HTMLElement>) => void;
}

export const CalendarShowMorePopover = ({ date, events, anchorEl, onClose, onSelectEvent, EventComponent }: Props) => (
  <Popover
    onClose={onClose}
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
  >
    <Stack gap="0.5rem" padding="0.5rem" sx={{ minWidth: 220, maxWidth: 320 }}>
      {date && (
        <Typography variant="subtitle2" color="text.secondary">
          {moment(date).format(DateFormats.Full)}
        </Typography>
      )}

      {events.map(event => (
        <Box
          key={event.id}
          onClick={clickEvent => onSelectEvent?.(event, clickEvent)}
          sx={theme => ({
            cursor: 'pointer',
            overflow: 'hidden',
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: `${theme.shape.borderRadius}px`,
            backgroundColor: theme.palette.background.paper,
            '&:hover': { backgroundColor: theme.palette.action.hover },
            borderLeft: `3px solid ${getPriorityColor(event.priority)(theme)}`,
          })}
        >
          {EventComponent ? <EventComponent event={event} /> : <Typography variant="caption">{event.title}</Typography>}
        </Box>
      ))}
    </Stack>
  </Popover>
);
